// Categorias do menu de ferramentas, na ordem do design aprovado.
// O grid desktop usa column-count:4 com preenchimento vertical, então esta
// ordem resulta em: col1 = Oportunidades + IA, col2 = Gestão + Automação,
// col3 = Análise + Assessoria, col4 = Treinamento + Outras.
// `name` precisa bater EXATAMENTE com service.category da API.
export interface ToolCategory {
  name: string;
  icon: string;
}

export const TOOL_CATEGORIES: ToolCategory[] = [
  { name: 'Oportunidades de Negócio', icon: 'target' },
  { name: 'Inteligência Artificial', icon: 'sparkles' },
  { name: 'Ferramentas de Gestão', icon: 'folder-kanban' },
  { name: 'Ferramentas de Automação', icon: 'bot' },
  { name: 'Análise Estratégica', icon: 'trending-up' },
  { name: 'Assessoria e Consultoria', icon: 'scale' },
  { name: 'Treinamento e Capacitação', icon: 'graduation-cap' },
  { name: 'Outras Ferramentas', icon: 'layout-grid' },
];

export default TOOL_CATEGORIES;
